export default __webpack_public_path__ + "static/media/20.066c3746.jpg";